import Vue from 'vue'
import Vuex from 'vuex'

import CategoriesStore from './CategoriesStore'
import SiteStore from './SiteStore'
import HomeStore from './HomeStore'
import CarouselsStore from './CarouselsStore'
import SchemaConfigStore from './SchemaConfigStore'
import SubscriberStore from './SubscriberStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    setting: {
      home: {
        middleList: [
          {
            id: 'history',
            name: '御窑历史'
          }
        ]
      }
    },
    default: {
      category: {
        panorama: null, // 全景御窑
        tour: null, // 游览信息
        transportation: null, // 交通信息
        today: null, // 今日风采
        video: null, // 御窑视频
        documents: null, // 资料文献
        famous: null, // 名人典故
        history: null, // 历史概况
        news: null, // 最新公告
        ticket: null, // 购票指南
        ceramic: null, // 珍品瓷器
        document: null, // 资料馆
        home: null, // 首页
        openingHour: null, // opening-hour开放时间
        talk: null, // 展览讲座
        www: null // 官网
      },
      bookingOffice: [
        {
          id: 'ctrip',
          name: '携程网',
          link: 'https://www.ctrip.com',
          logo_url: '/static/images/tour/ctrip.png'
        },
        {
          id: 'lvmama',
          name: '驴妈妈',
          link: 'http://www.lvmama.com'
        },
        {
          id: 'ly',
          name: '同程网',
          link: 'https://www.ly.com'
        },
        {
          id: 'meituan',
          name: '美团网',
          link: 'https://www.meituan.com'
        },
        {
          id: 'meituan1',
          name: '美团网1',
          link: 'https://www.meituan.com'
        },
        {
          id: 'ly1',
          name: '同程网1',
          link: 'https://www.ly.com'
        },
        {
          id: 'lvmama1',
          name: '驴妈妈1',
          link: 'http://www.lvmama.com'
        },
        {
          id: 'ctrip1',
          name: '携程网1',
          link: 'https://www.ctrip.com',
          logo_url: '/static/images/tour/ctrip.png'
        }
      ],
      searchType: [
        { value: 'all', name: '全部' },
        { value: 'document', name: '文章' },
        { value: 'video', name: '视频' },
        { value: 'panorama', name: '全景' },
        { value: 'ceramic', name: '瓷器' }
      ]
    }
  },
  modules: {
    CategoriesStore,
    SiteStore,
    HomeStore,
    CarouselsStore,
    SchemaConfigStore,
    SubscriberStore
  }
})
